module.exports = __webpack_public_path__ + "static/img/posture_souplesse_epaule.0483778.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imageTests/posture_souplesse_epaule.png
// module id = XF+C
// module chunks = 1